export default __webpack_public_path__ + "38fa5f2cb4955cf8cb9c241ca7d8be53.png";